import { ReactElement } from "react";

interface Props2 {
    label: string;
    text?: string;
    icon?: ReactElement<any, any>;
}

export function DatosGeneralesText({ label, text, icon }: Props2) {

    return (
        <div className="flex gap-2 mx-1 mb-[11px]">

            <div className="">
                {icon}
            </div>

            <p className="font-semibold">{label}</p>
            <p className="font-[400]">{text}</p>
        </div>
    );
}